export default class Mmovie {
    constructor() {
        this.videoID = null;
        this.player = null;
        //this.init();
    }

    init(videoID) {
        this.videoID = videoID;

        this.open();
        this.setup();

        this.eventBind();
    }

    resetEvent() {
        this.eventBind("reset");
    }

    open() {
        const modalid = "movie";
        const tgtmodal = document.querySelector(
            `.js-modal[data-modalID=${modalid}]`
        );

        document.body.classList.add("-inmodal");
        tgtmodal && tgtmodal.classList.add("-active");
    }

    setup() {
        const tag = document.createElement("script");
        const videoID = this.videoID;

        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player("player", {
                height: "360",
                width: "640",
                videoId: videoID, //デフォルト
                events: {
                    onStateChange: this.onStateChange.bind(this),
                    onError: this.onError,
                },
            });
        };
    }

    onError(e) {
        console.log(e);
    }

    onStateChange(e) {
        //プレミア公開も考慮してバッファリング(3)のタイミングに変更。そしてsetTimeoutさせる。
        if (e.data === 3) {
            setTimeout(() => {
                document.querySelector(
                    ".c-modal_movie__iframewrap"
                ).style.opacity = 1;
            }, 200);
        }
    }

    eventBind() {
        //this.loadVideo();
    }

    loadVideo() {
        //デフォルトでautoplayされる。
        const id = this.videoID;
        this.player.loadVideoById({ videoId: id });
    }
}
